import { lotteries } from '~/utils/constants/home.js'
import { mapperLotteries } from '~/utils/mappers/result.js'

const initialState = {
	showModalDetail: false,
	showModalDreams: false,
	country: null,
	lottery: null,
	numbers: null,
	user: null,
	prizes: null,
	selectIdDream: null,

	loading: false,
	current_page: 1,
	lottery_id: null,
	lotteries: null,
	analytics: null,
	pagination: null,

	loadingModalDreams: false,
	loadingImages: false,

	is_random: false,
	current_numbers: null,

	lotteries_result_current: null,
	showModalWelcome: false,

	isCompletedActiveAlarms: false,
	isMutipleBets: false,
	combinations: 0,
	amount: 1,

	showModalSignUp: false,
}

/**
 * Pinia store for the main results page.
 * Manages the selected country, lottery, and numbers together with the fetched prize data,
 * analytics, and UI state for modals (dreams, detail, welcome, sign-up).
 */
export const useResultStore = defineStore('result', {
	state: () => ({ ...initialState }),
	getters: {
		getDream: (state) => {
			if (state.selectIdDream === null) return null
			if (state.prizes === null) return null
			const findPrize = state.prizes.find((prize) => prize.id - 1 === state.selectIdDream)
			return findPrize ? findPrize : state.prizes[0]
		},
		getRowSelect: (state) => {
			if (state.selectIdDream === null) return null
			return state.lotteries[state.selectIdDream] ? state.lotteries[state.selectIdDream] : state.lotteries[0]
		},
		getLotterySelect: (state) => {
			if (state.lottery_id === null) return null
			return lotteries.find((lottery) => lottery.id === state.lottery_id) || lotteries[0]
		},
	},
	actions: {
		/** Sets any top-level state property by key. */
		SET_STATE_RESULT({ type, value }) {
			this[type] = value
		},
		/** Updates a nested property inside the array item at the given `position`. */
		SET_STATE_RESULT_ITEM({ type, value, position }) {
			if (!Array.isArray(this[type])) return

			const prizeExists = this[type].some((prize) => prize.id - 1 === position)
			if (!prizeExists) return

			const findPosition = this[type].findIndex((prize) => prize.id - 1 === position)
			this[type][findPosition][type] = value
		},
		/** Pushes a new `{ prizes, id }` entry into the specified array at the given `position`. */
		SET_STATE_RESULT_PRIZES({ type, value, position }) {
			if (this[type] === null) {
				this[type] = []
			}
			this[type].push({
				prizes: [...value],
				id: position + 1,
			})
		},
		/** Fetches prize data for a regular lottery and populates `lotteries`, `analytics`, and `pagination`. */
		async fetchPrizes(params) {
			const { $repository } = useNuxtApp()
			this.prizes = null
			this.loading = true
			const response = await $repository.lotteries.prizes.getPrizes(params)

			this.loading = false
			if (response.success === false) {
				this.lotteries = null
				return response
			}

			this.lottery_id = response?.result?.lottery_id
			this.lotteries = mapperLotteries(response?.result?.lotteries) ?? null
			this.analytics = response?.result?.analytics
			this.pagination = response?.result?.pagination
			return response
		},
		/** Fetches prize data for a classic lottery and populates `lotteries` and `pagination`. */
		async fetchPrizesClassic(params) {
			const { $repository } = useNuxtApp()
			this.prizes = null
			this.loading = true

			const response = await $repository.lotteries.classicPrizes.getPrizesClassic(params)
			this.loading = false
			if (response.success === false) return response

			this.lottery_id = response?.result?.lottery_id
			this.lotteries = mapperLotteries(response?.result?.lotteries) ?? []
			this.analytics = null
			this.pagination = response?.result?.pagination
			return response
		},
	},
})
